<template>
    <transition name="fade">
        <div class="confirm-to-teacher">
            <div class="modal-backdrop p-4"></div>
            <div class="modal-content">
                <div class="modal-body">
                    <div class="flex flex-col items-center">
                        <i class="fas fa-user-graduate text-red"></i>
                        <div class="text-center">
                            <p v-html="$t('confirm_to_teacher_description')" class="font-size-14"></p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer flex items-center pt-0">
                    <XButton @click="$emit('reject')" bg-color="transparent" color="#64748B" class="outlined flex-1">
                        {{ $t('popup_confirm_button_cancel') }}
                    </XButton>
                    <XButton
                        @click="$emit('accept')"
                        bg-color="var(--button-background-color)"
                        color="var(--button-text-color)"
                        class="flex-1"
                    >
                        {{ $t('popup_confirm_button_confirm') }}
                    </XButton>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import XButton from '@/components/v2/XButton'

export default {
    components: {
        XButton
    }
}
</script>

<style lang="scss">
.confirm-to-teacher {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 9999;

    .modal-backdrop {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 0 !important;
    }

    .modal-content {
        position: relative;
        max-width: 500px;
        width: 100%;
        background-color: #fff;
        border-radius: 6px;

        .modal-body {
            padding: 1.75rem 0.875rem 0.875rem 0.875rem;

            > div {
                row-gap: 0.875rem;
                padding-bottom: 0.875rem;

                i {
                    font-size: 3.5rem;
                    color: rgba(239, 68, 68, 1);
                }
            }
        }

        .modal-footer {
            column-gap: 0.875rem;
            padding: 0 0.875rem 0.875rem 0.875rem;

            button {
                border-radius: 6px;
                font-size: 0.875rem;

                &.outlined {
                    border: 1px solid #64748b;
                }
            }
        }
    }
}
</style>